import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "core-js/stable";
import "regenerator-runtime/runtime";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/normalize.css";
import "./assets/common.css";
import "./assets/font/font.css";
Vue.prototype.Urls='http://www.nttzzc.com'
// Vue.prototype.Urls='http://10.86.12.52:8084'
import Video from "video.js";
import "video.js/dist/video-js.css";
Vue.prototype.$video = Video;

import bus from "./bus/index.js";
Vue.config.productionTip = false;
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import qs from "qs";
Vue.prototype.$qs = qs;
Vue.prototype.$bus = bus;
const hls = require("videojs-contrib-hls");
Vue.use(hls)
// 字体大小自适应
//判断机型
if (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)) {
  // // console.log(true)
  // document.documentElement.style.width = '1920px'
  

    // window.location.href = 'http://www.nttzzc.com/Mobile/index.html'
 
  
} else {
  var fontbig = ((window.innerWidth / (1920 / 16)) * 100).toFixed(0) / 100;
  document.documentElement.style.fontSize = fontbig + "px";
  window.onresize = function () {
    var fontbig = ((window.innerWidth / (1920 / 16)) * 100).toFixed(0) / 100;
    document.documentElement.style.fontSize = fontbig + "px";
  };

}


Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");